
import { Vue, Component, Watch } from "vue-property-decorator";
import { uiStore } from "@/store/store";

@Component
export default class PreviewModeCloseButton extends Vue {
  togglePreviewMode() {
    uiStore.togglePreviewMode();
  }

  get isPreviewMode() {
    return uiStore.isPreviewMode;
  }

  @Watch("isPreviewMode", {
    immediate: true
  })
  onIsPreviewModeChange() {
    // Replay animations when entering preview mode
    if (this.isPreviewMode) {
      const event = new Event("breakdance_play_animations", { bubbles: true });
      window.Breakdance.canvas.document.dispatchEvent(event);
    }
  }
}
